import React, { useState } from 'react';
import { useAuth } from '../App';

// Persistent bar shown across the real app while a visitor explores the live demo.
const DemoSessionBanner = () => {
  const { logout } = useAuth();
  const [active, setActive] = useState(sessionStorage.getItem('scc_demo') === '1');

  if (!active) return null;

  const clearSession = () => {
    sessionStorage.removeItem('scc_demo');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setActive(false);
    logout();
  };

  const exitDemo = () => {
    clearSession();
    // Full navigation avoids a ProtectedRoute race that would land on /login
    window.location.replace('/');
  };

  const startFree = () => {
    // Must sign out of the demo sandbox first, otherwise /signup redirects back
    clearSession();
    window.location.replace('/signup');
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-gradient-to-r from-green-600 to-green-700 text-white px-4 py-2.5 shadow-[0_-4px_12px_rgba(0,0,0,0.15)]"
      data-testid="demo-session-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium">
          <span>🎮 DEMO MODE</span>
          <span className="text-green-100 hidden sm:inline">
            You're exploring the full app with sample data — nothing here is real.
          </span>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={startFree}
            className="bg-yellow-400 text-green-900 hover:bg-yellow-300 px-3.5 py-1.5 rounded-lg text-sm font-bold whitespace-nowrap"
            data-testid="demo-session-start-free"
          >
            Ready to go live? Start Free
          </button>
          <button
            onClick={exitDemo}
            className="text-green-100 hover:text-white text-sm underline whitespace-nowrap"
            data-testid="demo-session-exit"
          >
            Exit Demo
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoSessionBanner;
